(ns practitest.frontend.components2.dashboard.charts.gauge
  (:require [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.svg :refer [render!]]
            [practitest.frontend.components2.dashboard.charts.render-helpers :as rh]
            [practitest.frontend.components2.dashboard.charts.readiness-gauge.helpers :as h]))

(def config
  (let [start-angle      (- (* Math/PI 0.8))
        arc-weight-ratio 0.14
        arc-radius       100]
    #:config
    {:arc-weight-ratio    arc-weight-ratio
     :arc-radius          arc-radius
     :arc-weight          (* arc-radius arc-weight-ratio)
     :icon-radius         7.5
     :tick-count          10
     :tick-length         6
     :tick-padding        6
     :tick-inset          0.45
     :tick-width          0.6
     :transition-duration 600
     :start-angle         start-angle
     :end-angle           (- start-angle)}))

(defn svg [{:keys        [value display-value not-available? toggle-tooltip! tooltip-text label status-icon level]
            :config/keys [tick-count arc-radius transition-duration]
            :as          ctx}]
  (let [arc-bg    (h/arc ctx)
        arc-value (assoc arc-bg :to [:t (or value 0)])
        tick      (h/tick ctx)
        tooltip!  #(toggle-tooltip! {:text    tooltip-text
                                     :element (.-currentTarget %)})]
    [:svg {:view-box [:svg/polar arc-radius]}
     [:g {:class (some-> level name)}
      [:svg/arc.arc-bg arc-bg]
      [:svg/transition {:duration transition-duration}
       [:svg/arc.arc-value arc-value]]

      (for [i (range (inc tick-count))]
        [:svg/line (merge tick {:angle [:t (/ i tick-count)]})])

      (if not-available?
        [:text.value-text "N/A"]
        [:g {:on-mouse-enter tooltip!
             :on-mouse-leave tooltip!}
         [:svg/vstack {:gap 6}
          [:text.value-text display-value]
          [:svg/hstack {:gap 4}
           (when status-icon (h/status-icon ctx))
           [:text.label-text label]]]])]]))

(defn- score->status [score {:keys [low medium]}]
  (let [score (* score 100)]
    (condp < score
      medium :high
      low    :medium
      :low)))

(defn- truncate [text max-chars]
  (if (<= (count text) max-chars)
    text
    (str (subs text 0 max-chars) "...")))

(defmethod p/transform-data ::chart/gauge [{:chart/keys [data] :as chart}]
  (let [value (:value data)]
    (cond-> chart
      value (assoc :value value
                   :level (score->status value (:thresholds data))
                   :label (:criteria data)))))

(defmethod p/render! ::chart/gauge [chart ctx svg-el]
  (let [{:keys [value label]} chart
        display-label (truncate (str "Value: " label) 20)
        display-value (str (.toFixed (* value 100) 2) "%")]
    (->> (assoc chart :label         display-label
                      :tooltip-text  label
                      :display-value display-value)
         (merge config ctx)
         svg
         (render! svg-el))))

(defmethod p/svg-for-export ::chart/gauge [_chart svg-element]
  (let [clone (rh/clone-svg svg-element)]
    (rh/embed-styles! svg-element clone
                      [".arc-bg" ".arc-value" ".tick" ".value-text" ".label-text"])
    clone))
